import {
  aDayInMilliseconds,
  aWeekInMilliseconds,
} from '@wwe-portal/utils/date';

import { CalendarEvent } from '@wwe-portal/entities/calendar.type';

export function secondMinMax(arr: number[], point: 'min' | 'max') {
  const lArr = [...arr];
  const minMaxPoint = Math[point].apply(null, lArr);
  lArr.splice(lArr.indexOf(minMaxPoint), 1);

  return Math[point].apply(null, lArr);
}

export const isOnGoingEvent = (
  event: CalendarEvent,
  { startPSTDate }: { startPSTDate: number }
) => {
  const eventStartTs = new Date(event.startDate).getTime();
  const eventEndTs = new Date(event.endDate).getTime();
  return eventStartTs <= startPSTDate && eventEndTs >= startPSTDate;
};

export const isWithinADayEvent = (
  event: CalendarEvent,
  { startPSTDate }: { startPSTDate: number }
) => {
  const eventStartTs = new Date(event.startDate).getTime();
  const endPSTDate = startPSTDate + aDayInMilliseconds;
  return eventStartTs >= startPSTDate && eventStartTs <= endPSTDate;
};

export const compareEvent = (eventA: CalendarEvent, eventB: CalendarEvent) => {
  return (
    new Date(eventA.endDate).getTime() - new Date(eventB.endDate).getTime()
  );
};

export const isTomorrowEvent = (
  event: CalendarEvent,
  { startPSTDate }: { startPSTDate: number }
) => {
  const startTomorrow = startPSTDate + aDayInMilliseconds;
  return isWithinADayEvent(event, { startPSTDate: startTomorrow });
};

export const isWithinAWeekEvent = (
  event: CalendarEvent,
  { startPSTWeek }: { startPSTWeek: number }
) => {
  const eventStartTs = new Date(event.startDate).getTime();
  const endPSTWeek = startPSTWeek + aWeekInMilliseconds;
  return eventStartTs >= startPSTWeek && eventStartTs <= endPSTWeek;
};

export const isNextWeekEvent = (
  event: CalendarEvent,
  { startPSTWeek }: { startPSTWeek: number }
) => {
  const startNextWeek = startPSTWeek + aWeekInMilliseconds;
  return isWithinAWeekEvent(event, { startPSTWeek: startNextWeek });
};
